import React from "react";

export function FandomActions() {
	return (
		'Fandom Actions'
	)
}
